import { fetchUsers } from '@app/modules/admin/api';
import { User, UserRole } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';

export function useAllUsersQuery(excludeClientAdmins = true) {
  const query = useQuery({
    queryKey: ['users', 'all'],
    queryFn: () =>
      fetchUsers({
        pageSize: 999,
      }),
  });

  const users: User[] = excludeClientAdmins
    ? (query.data?.results.filter((u) => u.role !== UserRole.CLIENT_ADMIN) ?? [])
    : (query.data?.results ?? []);

  return {
    ...query,
    users,
  };
}
